export { default } from '@ember/render-modifiers/modifiers/did-insert';
